import { ReactElement, useEffect, useRef, useState } from 'react';
import { BottomDrawerModel, Dropdown } from '@components/common';
import { useFormik } from 'formik';
import { useOutsideDialogClose } from '@hooks/useOutsideDialogClose';
import { ISSSummeryFiltersProps } from '.';
import { useSsSiteSummaryListingStore, SSSiteSummaryFilterObject } from '@store/ssSiteSummaryFilterStore';
import { getDatabase } from '@rxdb/config/databaseConfig';
import { ISpecialistDetails } from '@services/hooks/site-specialist';

export const SsSiteSummaryFilters = (props: ISSSummeryFiltersProps): ReactElement => {
	const { openFilters, closeFilters } = props;
	const dialogRef = useRef<HTMLDivElement | null>(null);
	useOutsideDialogClose({ dialogRef, callBackFunction: closeFilters });
	const { updateFilter, resetSiteSummaryFilter, allSSSiteSummaryFilter } = useSsSiteSummaryListingStore();
	const [ss_list, setSSList] = useState<ISpecialistDetails[]>([]);

	const formik = useFormik({
		initialValues: allSSSiteSummaryFilter,
		onSubmit: (values: SSSiteSummaryFilterObject): void => {
			updateFilter(values);
			closeFilters();
		},
	});

	const handleSubmit = (): void => {
		formik.handleSubmit();
	};

	const clearAll = (): void => {
		resetSiteSummaryFilter();
		closeFilters();
	};

	const isFilterChecked = formik.values.ss_code;

	const getDataFromIndexDb = async (): Promise<void> => {
		try {
			const db = await getDatabase();
			const result = await db.sitespecialist_list.find().exec();
			if (result?.length > 0) {
				const tempData: ISpecialistDetails[] = result.map((ele: { _data: ISpecialistDetails[] }) => ele?._data);
				const data = tempData?.map((item) => {
					return { id: item.sfid, value: item.mh2code_c };
				});
				setSSList(data);
			}
		} catch (error) {
			setSSList([]);
		}
	};

	useEffect(() => {
		getDataFromIndexDb();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [allSSSiteSummaryFilter]);

	return (
		<BottomDrawerModel openModelStatus={openFilters} modelId="filter-main-wrapper">
			<div className="container">
				<button
					type="button"
					aria-label="filter popup"
					className="filter-sort-icon icon-filter"
					onClick={closeFilters}
				></button>
				<div ref={dialogRef} className="filter-drawer-inner-wrapper filter">
					<span className="filter-title">
						<p className="h2">Filter</p>
						<button
							className="clear-all"
							type="button"
							hidden={!isFilterChecked}
							onClick={clearAll}
							aria-label="Clear All"
						>
							Clear All
						</button>
					</span>
					<form>
						<div className="form-fieldset row">
							<div className="d-col">
								<span className="form-title h4">
									<span className="icon-shield mr-2"></span>
									Site Specialist
								</span>
								<Dropdown
									name="ss_code"
									id="ss_code"
									title={formik.values.ss_code}
									options={ss_list}
									setFieldValue={formik.setFieldValue}
								/>
							</div>
						</div>
					</form>
					<div className="d-col submit">
						<button
							type="submit"
							disabled={!isFilterChecked}
							onClick={handleSubmit}
							className="btn btn-primary btn-medium"
						>
							Submit
						</button>
					</div>
				</div>
			</div>
		</BottomDrawerModel>
	);
};
